import TabsNormal from './TabsNormal'
import TabsRounded from './TabsRounded'
import type { TabLabel, TabsProps } from './types'

export default function Tabs<T extends TabLabel>(props: TabsProps<T>): React.ReactElement {
  const { variant } = props
  if (variant === 'rounded') {
    return <TabsRounded {...props} />
  }
  return <TabsNormal {...props} />
}
